import { updateClientProfileInputSchema } from '@/entities/client';
import { rejectEmptyPronouns } from '@/shared/lib/reject-empty-pronouns';

export const editClientProfileFormSchema =
    updateClientProfileInputSchema.superRefine(rejectEmptyPronouns);
